// extracted by mini-css-extract-plugin
export default {"subheading":"style_subheading__8XtYI","margin":"style_margin__bl40o"};